<div [ngClass]="{
'alert-primary': alertMessage?.severity === 2,
'alert-success': alertMessage?.severity === 1,
'alert-warning': alertMessage?.severity === 3,
'alert-danger': (alertMessage?.severity ?? 0) >= 4
}" class="alert">
  {{ alertMessage?.getTranslatedMessage(this.translateService.currentLang) }}
</div>
